<pbc-filter [config]="KundenGruppesFilterConfig" [filter]="kundenGruppes.filter$ | async" (filterChange)="kundenGruppes.filter$.next($event)"></pbc-filter>
